export const GoOrderRouting = [
  {
    path: "/expense/goorder",
    name: "expense-goorder",
    meta: { title: "订购中心" },
    component: () =>
      import(/* webpackChunkName: "expense-goorder" */ "@/views/expense/goorder/index.vue"),
  },
];
